import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.353 4.767a.67.67 0 0 0-.666 0l-2.354 1.16a2 2 0 0 0-2-1.927h-6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-1.927l2.374 1.187q.137.071.293.073a.666.666 0 0 0 .667-.666V5.333a.67.67 0 0 0-.314-.566M10 10a.667.667 0 0 1-.667.667h-6A.667.667 0 0 1 2.667 10V6a.667.667 0 0 1 .666-.667h6A.667.667 0 0 1 10 6zm3.333-.413-2-1V7.413l2-1z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })